<template>
  <modal :show.sync="showModal">
    <h6 slot="header" class="modal-title">Editar Sucursal: {{fetchBranch.name}}</h6>
    <form class="needs-validation" id="formEditBranch"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="branch.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sponsor:">
                    <el-select  v-model="branch.sponsor.value" filterable
                                placeholder="Seleccione Sponsor">
                        <el-option v-for="option in selectSponsors"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      
      <!--
      <base-input>
        <base-checkbox v-model="model.agree">
          Agree to terms and conditions
        </base-checkbox>
      </base-input>
      -->
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formEditBranch">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
import { Select, Option } from 'element-ui';

  export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
      return {
        validated: false,
        branch: {
          name: '',
          sponsor: { label: '', value: ''}
        },
        fetchBranch: {
          name: '',

        },
        showModal: false,
        change_password: "0",
        reglasConfirmacion: '',
        reglasPassword: '',
        branch_id: null,
        selectSponsors: []
      }
    },
    methods: {
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(){
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          
          if( response ){
            
            vm.axios({
                method: 'PUT',
                url: 'api/edit_branch',
                data: {   
                          branch: vm.branch.id, 
                          name: vm.branch.name,
                          sponsor: vm.branch.sponsor.value
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Sucursal editada exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo modificar la sucursal',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
          
        }).catch( reason => {
          console.log(reason);
        });
      },
      fetchDataTeam(branch_id)
      {
        var vm = this;
        
        return this.axios({
            method: 'GET',
            url: 'api/edit_branch?branch='+branch_id
        }).then(response => {
            this.fetchBranch.name = this.branch.name = response.data.name;
            this.fetchBranch.id = this.branch.id = response.data.id;
            this.selectSponsors = response.data.sponsors;
            this.branch.sponsor = response.data.sponsor;
            this.showModal = true;
            this.branch_id = branch_id;
        }).catch( error => {
            console.log(error);
        })
        ;
      },
    },
    mounted()
    {
        
    },
    created()
    {
      this.$parent.$on('loadModalEditBranch', (branch_id) => { this.fetchDataTeam(branch_id) } );
    },
  }
</script>
<style>
</style>
